<template>
  <div v-if="!ownerData" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-1">
              <router-link to="/">{{$t('myproperty.breadcrumb_1')}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li
              class="breadcrumb-item mx-2 almarai-bold"
              aria-current="page"
            >
              {{$t('myproperty.breadcrumb_2')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="text-center" v-if="hasError"> <errorAlert :alertMessage="message" :errorNumber="errorNumber" /> </div>
    <div class="row pt-4">
      <div class="col-12">
        <div v-if="ownerData" class="text-center"><mainloader /></div>
        <div v-else class="row">
          <div class="col-12 col-md-5 col-lg-4 mb-3" v-for="(row,index) in items" :key="index">
            <router-link :to="'/rental/'+row.id">
              <div class="card card-border m-auto">
                <div class="card-body position-R">
                  <div class="row position-Abso pt-2">
                    <div class="col-auto tag-style  pt-2">
                      <span>{{ ownerStatus .statusChoices[row.status]}}</span>
                    </div>
                  </div>
                  <swiper v-if="row.mediaFiles.length" class="text-center" 
                    :autoplay="{ delay: 2500, disableOnInteraction: false,}" :modules="modules" 
                    :pagination="{ clickable: true }" :navigation="false"
                  >
                    <swiper-slide v-for="(img, ind) in row.mediaFiles" :key="ind">
                      <img :src="MEDIA_URL+img.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <img src="/assets/images/defaultImage.jpg" class="w-100 br-radius" alt="">
                  </div>
                  <div class="almarai-regular">{{ row.title }}</div>
                  <div class="d-flex pt-2">
                    <i class="fa-solid fa-location-dot gray-color"></i>
                    <div class="mx-2 gray-color fonttext-14">{{ row.City.name }}</div>
                    <div class="gray-color fonttext-14">{{ row.Neighborhood.name }}</div>
                  </div>
                  <hr class="border-color-w">
                  <div class="row space">
                    <div class="col-7 col-lg-7 button-center">
                      <div class="row">
                        <div class="col-auto">
                          <img src="/assets/images/icons/Frame-8.png" class="width-48" alt="">
                        </div>
                        <div class="col">
                          <div class="fonttext-14 gray-color">{{$t('myproperty.Collected')}}</div>
                          <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                          <span class="green-color-F">{{ row.collectedAmount }}</span>
                          <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-5 col-lg-5">
                      <router-link :to="'/rental/'+row.id">
                        <div class="moreKnow-btn">{{$t('myproperty.more')}}</div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="!ownerData && !items.length">
      <div class="col">
        <div class="row">
          <div  class="col">
            <div class="text-center pb-3">
              <img src="/assets/images/icons/Frame-48.png" class="img-fluid" alt="">
            </div>
            <div class="almarai-bold pt-2 text-center">{{$t('myproperty.title_1')}}</div>
            <div class="text-center almarai-regular gray-color fonttext-14">
              <span> {{$t('myproperty.title_2')}} </span>
            </div>
          </div>
        </div>
        <div class="row py-4 justify-content-center">
          <div class="col-6 text-center py-3">
            <router-link to="/">
              <button class="submit-button form-control almarai-bold"> {{$t('myproperty.title_3')}} </button>
            </router-link>
          </div>  
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { mapGetters } from 'vuex';
export default {
  name: 'myproperty',
  components: { Swiper, SwiperSlide },
  setup() {
    return {
      modules: [Pagination, Navigation, Autoplay]
    };
  },
  data(){
    return {
      hasError: false,
      message:  "",
      errorNumber: 0,
      ownerData: false,
      items: [],
      userLang: 'ar',
    }
  },
  computed: {
    ...mapGetters(['MEDIA_URL', 'GET_USER', 'ISLOADING'])
  },
  methods:{
    myOwners(){
      this.hasError = false;
      this.ownerData = true;
      this.$http.get("/api/properties/owners").then(res => {
        this.items = res.data.rows;
        this.ownerStatus = res.data;
        this.ownerData = false;
      }).catch(err => {
        // console.log(err);
        this.ownerData = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    }
  },
  created(){
    this.myOwners();
    this.userLang = localStorage.getItem('lang') ??  'ar';
  }
}
</script>